import React from "react"
import SectionPageMargin from '../Layout/Section/SectionPageMargin'
import Grid2 from '../Layout/Grid2/Grid2'
import GridItem from '../Layout/GridItem/GridItem'
import Spacer from '../Layout/Spacer/Spacer'
import StyledLink from '../Type/StyledLink'
import Heading2 from '../Type/Heading2'
import Paragraph1 from '../Type/Paragraph1'
import FlexCenter from '../Layout/Flex/FlexCenter'
import RecentSales from '../RecentSales/RecentSales'

const ReadyToGetStarted = () => {
    return (
      <SectionPageMargin bgColor="#f8f8f9" marginBottom="0px">
        <Grid2 style={{paddingBottom: '60px'}}>
          <GridItem>
            <Heading2>Ready to get your selling started?</Heading2>
            <Paragraph1>
              To get started, all you need to do is tell us a little about your car. We will then let you know our valuation 
              (a recommended listing price) for the car, along with a no-obligation quote from Summon for our concierge services.
            </Paragraph1>
            <Paragraph1>
              <StyledLink to="https://value.summon.com.au/">Request a no-obligation valuation</StyledLink>
            </Paragraph1>
            <Spacer height="50px" />
          </GridItem>
          <GridItem>
            <FlexCenter>
              <RecentSales />
						</FlexCenter>
          </GridItem>
      </Grid2>
    </SectionPageMargin>
  )
}

export default ReadyToGetStarted

